import styled from 'styled-components';

import { size } from '../layout/helpers';
import { theme } from '../layout/theme';

export const ThumbnailList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${size(1)};

  ${theme.screens.Lg} {
    gap: ${size(2)};
  }
`;

export const Thumbnail = styled.button`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: ${size(8)};
  padding: ${size(1)};
  border-radius: 4px;
  border: 1px solid ${theme.colors.border.alt};
  transition: border-color 75ms;
  position: relative;

  &:hover,
  &.active {
    border: 1px solid ${theme.colors.border.hover};
  }

  &:after {
    content: '';
    padding-bottom: 100%;
  }

  ${theme.screens.Lg} {
    width: ${size(14)};
  }
`;

export const ThumbnailIcon = styled.div`
  border-radius: 50%;
  width: ${size(5)};
  height: ${size(5)};
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.3);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  .icon {
    color: ${theme.colors.bg.main};
    font-size: 18px;
  }

  &.small {
    width: ${size(3)};
    height: ${size(3)};

    .icon {
      font-size: 10px;
    }
  }
`;

export const ThumbnailImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;

  &.squared {
    aspect-ratio: 1 / 1;
  }
`;

export const ThumbnailAlt = styled.div`
  border-radius: 4px;
  position: relative;
  display: flex;
  justify-items: center;
  align-items: center;

  &:after {
    content: '';
    padding-bottom: 100%;
  }

  ${ThumbnailImage} {
    border-radius: 4px;
  }
`;

export const SelectedIconContainer = styled.div`
  position: absolute;
  top: ${size(0.5)};
  left: ${size(0.5)};
  width: ${size(3)};
  height: ${size(3)};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${theme.colors.ui.positive};
  color: ${theme.colors.text.onColor};
  font-size: 24px;

  &.small {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  ${theme.screens.Md} {
    &:not(.small) {
      width: ${size(3)};
      height: ${size(3)};
      font-size: 16px;
    }
  }
`;
